import React, { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, Check, MapPin } from "lucide-react";
import { adminApi } from "../../lib/adminAuth";
import { api } from "../../lib/api";
import { Modal } from "./AdminCoupons";

const empty = {
  name: "",
  slug: "",
  description: "",
  address: "",
  neighborhood: "",
  lat: -33.45,
  lng: -70.65,
  phone: "",
  website: "",
  instagram: "",
  cover_photo: "",
  beer_types: [],
  ambient: [],
  price_level: 2,
  featured: false,
};

export default function AdminVenues() {
  const [venues, setVenues] = useState([]);
  const [editing, setEditing] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const load = () => api.listVenues().then(setVenues).catch(() => {});
  useEffect(load, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const payload = {
        ...editing,
        lat: parseFloat(editing.lat),
        lng: parseFloat(editing.lng),
        price_level: parseInt(editing.price_level, 10),
        beer_types: typeof editing.beer_types === "string" ? editing.beer_types.split(",").map((s) => s.trim()).filter(Boolean) : editing.beer_types,
        ambient: typeof editing.ambient === "string" ? editing.ambient.split(",").map((s) => s.trim()).filter(Boolean) : editing.ambient,
      };
      if (editing.id) {
        await adminApi.updateVenue(editing.id, payload);
      } else {
        await adminApi.createVenue(payload);
      }
      setEditing(null);
      load();
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Error guardando local");
    } finally {
      setBusy(false);
    }
  };

  const remove = async (v) => {
    if (!window.confirm(`¿Eliminar "${v.name}"? Se borrarán también sus Huesos, reseñas y check-ins.`)) return;
    await adminApi.deleteVenue(v.id);
    load();
  };

  return (
    <div data-testid="admin-venues-page" className="space-y-6">
      <header className="flex items-end justify-between gap-4">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#FEBA01]">Catálogo</div>
          <h1 className="font-display text-4xl uppercase tracking-tight">Locales</h1>
          <p className="text-sm text-[#A3A3A3] mt-1">{venues.length} cervecerías registradas.</p>
        </div>
        <button
          onClick={() => setEditing({ ...empty })}
          className="btn-brutal bg-[#FEBA01] text-black font-display uppercase px-4 py-2 inline-flex items-center gap-2 shadow-brutal-white"
          data-testid="admin-venue-new-btn"
        >
          <Plus size={16} /> Nuevo local
        </button>
      </header>

      <div className="bg-[#1A1A1A] border-2 border-[#333] divide-y divide-[#333]">
        {venues.map((v) => (
          <div key={v.id} className="flex items-center justify-between gap-3 px-4 py-3" data-testid={`admin-venue-${v.id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-display uppercase truncate">{v.name}</div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-[#A3A3A3] mt-0.5 flex items-center gap-1">
                <MapPin size={10} /> {v.neighborhood} · {v.rating_avg}★ ({v.rating_count})
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button onClick={() => setEditing({ ...v, beer_types: (v.beer_types || []).join(", "), ambient: (v.ambient || []).join(", ") })} className="border-2 border-[#FEBA01] text-[#FEBA01] hover:bg-[#FEBA01] hover:text-black p-2" aria-label="Editar" data-testid={`admin-venue-edit-${v.id}`}>
                <Pencil size={14} />
              </button>
              <button onClick={() => remove(v)} className="border-2 border-red-500 text-red-400 hover:bg-red-500 hover:text-white p-2" aria-label="Eliminar" data-testid={`admin-venue-delete-${v.id}`}>
                <Trash2 size={14} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <Modal onClose={() => setEditing(null)} title={editing.id ? "Editar local" : "Nuevo local"} testid="admin-venue-modal">
          <form onSubmit={onSubmit} className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <Field label="Nombre *">
                <input required value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className="inp" data-testid="admin-venue-name" />
              </Field>
              <Field label="Slug *">
                <input required value={editing.slug} onChange={(e) => setEditing({ ...editing, slug: e.target.value })} placeholder="kross-bar-santiago" className="inp" data-testid="admin-venue-slug" />
              </Field>
            </div>
            <Field label="Descripción *">
              <textarea required rows={3} value={editing.description} onChange={(e) => setEditing({ ...editing, description: e.target.value })} className="inp" data-testid="admin-venue-description" />
            </Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Barrio *"><input required value={editing.neighborhood} onChange={(e) => setEditing({ ...editing, neighborhood: e.target.value })} className="inp" /></Field>
              <Field label="Dirección *"><input required value={editing.address} onChange={(e) => setEditing({ ...editing, address: e.target.value })} className="inp" /></Field>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Lat *"><input required type="number" step="any" value={editing.lat} onChange={(e) => setEditing({ ...editing, lat: e.target.value })} className="inp" /></Field>
              <Field label="Lng *"><input required type="number" step="any" value={editing.lng} onChange={(e) => setEditing({ ...editing, lng: e.target.value })} className="inp" /></Field>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Teléfono"><input value={editing.phone || ""} onChange={(e) => setEditing({ ...editing, phone: e.target.value })} className="inp" /></Field>
              <Field label="Instagram"><input value={editing.instagram || ""} onChange={(e) => setEditing({ ...editing, instagram: e.target.value })} placeholder="@elkiltro" className="inp" /></Field>
            </div>
            <Field label="Web"><input value={editing.website || ""} onChange={(e) => setEditing({ ...editing, website: e.target.value })} placeholder="https://" className="inp" /></Field>
            <Field label="Foto de portada (URL)"><input value={editing.cover_photo || ""} onChange={(e) => setEditing({ ...editing, cover_photo: e.target.value })} placeholder="https://images.unsplash.com/..." className="inp" /></Field>
            <Field label="Tipos de cerveza (separados por coma)"><input value={editing.beer_types} onChange={(e) => setEditing({ ...editing, beer_types: e.target.value })} placeholder="IPA, Stout, Lager" className="inp" /></Field>
            <Field label="Ambiente (separados por coma)"><input value={editing.ambient} onChange={(e) => setEditing({ ...editing, ambient: e.target.value })} placeholder="terraza, brutalista, vinilos" className="inp" /></Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Nivel de precio (1-4)">
                <select value={editing.price_level} onChange={(e) => setEditing({ ...editing, price_level: e.target.value })} className="inp">
                  {[1, 2, 3, 4].map((n) => <option key={n} value={n}>{"$".repeat(n)}</option>)}
                </select>
              </Field>
              <label className="flex items-center gap-2 font-mono text-xs uppercase text-[#A3A3A3] mt-6">
                <input type="checkbox" checked={!!editing.featured} onChange={(e) => setEditing({ ...editing, featured: e.target.checked })} />
                Top Kiltro (destacado)
              </label>
            </div>
            {err && <div className="text-sm text-red-400">{err}</div>}
            <div className="flex gap-2 pt-2">
              <button type="submit" disabled={busy} className="btn-brutal bg-[#FEBA01] text-black font-display uppercase px-4 py-2 shadow-brutal-white inline-flex items-center gap-2 disabled:opacity-50" data-testid="admin-venue-save">
                <Check size={16} /> {busy ? "Guardando…" : "Guardar"}
              </button>
              <button type="button" onClick={() => setEditing(null)} className="border-2 border-[#333] text-[#A3A3A3] hover:text-white px-4 py-2 font-display uppercase">
                Cancelar
              </button>
            </div>
          </form>
        </Modal>
      )}

      <style>{`.inp { width: 100%; background:#0A0A0A; border:2px solid #333; padding: 0.5rem 0.75rem; outline: none; color:#F5F5F5; }
        .inp:focus { border-color: #FEBA01; }`}</style>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="block font-mono text-[10px] uppercase tracking-widest text-[#A3A3A3] mb-1">{label}</span>
      {children}
    </label>
  );
}
